import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Multiselect from 'vue-multiselect'
import {ClientTable} from 'vue-tables-2';

import AnnuaireRCPForm from "./AnnuaireRCPForm.vue";

Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.config.devtools = true;

// register globally
Vue.component('multiselect', Multiselect)
Vue.use(ClientTable);

new Vue({
    render: h => h(AnnuaireRCPForm)
}).$mount("#annuaire-rcp-form");
